(function() {
  'use strict';

  // ============================================================
  // STORE DATA - Update if hours/addresses change
  // ============================================================
  var STORES = [
    {
      id: 'middlebrook',
      name: 'Agri Feed Pet Supply',
      shortName: 'Middlebrook Pike',
      address: '5716 Middlebrook Pike',
      city: 'Knoxville, TN',
      zip: '37921',
      phone: '865-584-3959',
      phoneRaw: '8655843959',
      directionsUrl: 'https://maps.google.com/?q=5716+Middlebrook+Pike+Knoxville+TN+37921',
      // Hours: index 0=Sun, 1=Mon, 2=Tue, 3=Wed, 4=Thu, 5=Fri, 6=Sat
      // null = closed, otherwise [openHour, openMin, closeHour, closeMin] in 24hr
      hours: [
        null,                  // Sunday - closed
        [9, 0, 18, 30],        // Monday
        [9, 0, 18, 30],        // Tuesday
        [9, 0, 18, 30],        // Wednesday
        [9, 0, 18, 30],        // Thursday
        [9, 0, 18, 30],        // Friday
        [9, 0, 18, 30],        // Saturday
      ]
    },
    {
      id: 'kingston',
      name: 'Agri Feed Pet Supply',
      shortName: 'Kingston Pike',
      address: '10420 Kingston Pike, Suite C',
      city: 'Knoxville, TN',
      zip: '37922',
      phone: '865-691-7787',
      phoneRaw: '8656917787',
      directionsUrl: 'https://maps.google.com/?q=10420+Kingston+Pike+Suite+C+Knoxville+TN+37922',
      hours: [
        null,
        [9, 0, 18, 30],
        [9, 0, 18, 30],
        [9, 0, 18, 30],
        [9, 0, 18, 30],
        [9, 0, 18, 30],
        [9, 0, 18, 30],
      ]
    }
  ];

  var COOKIE_NAME = 'agri_selected_store';
  var COOKIE_DAYS = 365;

  // ============================================================
  // UTILITIES
  // ============================================================
  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }

  function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function getStoreStatus(store) {
    var now = new Date();
    var day = now.getDay();
    var hours = store.hours[day];

    if (!hours) {
      return { isOpen: false, text: 'Closed today' };
    }

    var currentMins = now.getHours() * 60 + now.getMinutes();
    var openMins = hours[0] * 60 + hours[1];
    var closeMins = hours[2] * 60 + hours[3];

    if (currentMins >= openMins && currentMins < closeMins) {
      var closeHour = hours[2];
      var closeMin = hours[3];
      var ampm = closeHour >= 12 ? 'PM' : 'AM';
      var displayHour = closeHour > 12 ? closeHour - 12 : closeHour;
      var displayMin = closeMin === 0 ? '00' : closeMin;
      return { isOpen: true, text: 'Open until ' + displayHour + ':' + displayMin + ' ' + ampm };
    } else if (currentMins < openMins) {
      var openHour = hours[0];
      var openMin = hours[1];
      var ampm2 = openHour >= 12 ? 'PM' : 'AM';
      var dHour = openHour > 12 ? openHour - 12 : openHour;
      var dMin = openMin === 0 ? '00' : openMin;
      return { isOpen: false, text: 'Opens at ' + dHour + ':' + dMin + ' ' + ampm2 };
    } else {
      return { isOpen: false, text: 'Closed' };
    }
  }

  function getSelectedStore() {
    var savedId = getCookie(COOKIE_NAME);
    if (savedId) {
      for (var i = 0; i < STORES.length; i++) {
        if (STORES[i].id === savedId) return STORES[i];
      }
    }
    return STORES[0]; // default to Middlebrook
  }

  // ============================================================
  // CSS INJECTION
  // ============================================================
  function injectStyles() {
    var css = `
      /* ===== AGRI STORE SELECTOR WIDGET ===== */
      #agri-store-selector-bar {
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        padding: 4px 8px;
        border-radius: 6px;
        transition: background 0.2s ease;
        user-select: none;
      }
      #agri-store-selector-bar:hover {
        background: rgba(255,255,255,0.1);
      }
      #agri-store-selector-bar .agri-ss-icon {
        font-size: 16px;
        flex-shrink: 0;
      }
      #agri-store-selector-bar .agri-ss-info {
        display: flex;
        flex-direction: column;
        line-height: 1.2;
      }
      #agri-store-selector-bar .agri-ss-location {
        font-weight: 700;
        font-size: 14px;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        color: inherit;
      }
      #agri-store-selector-bar .agri-ss-city {
        font-size: 13px;
        opacity: 0.85;
        color: inherit;
      }
      #agri-store-selector-bar .agri-ss-phone {
        font-size: 13px;
        font-weight: 600;
        color: #2d5a27;
      }
      #agri-store-selector-bar .agri-ss-status {
        font-size: 12px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.08em;
      }
      #agri-store-selector-bar .agri-ss-status.open { color: #2d5a27; }
      #agri-store-selector-bar .agri-ss-status.closed { color: #fca5a5; }
      #agri-store-selector-bar .agri-ss-chevron {
        font-size: 12px;
        opacity: 0.7;
        transition: transform 0.2s ease;
        flex-shrink: 0;
      }
      #agri-store-selector-bar.active .agri-ss-chevron {
        transform: rotate(180deg);
      }

      /* ===== MODAL OVERLAY ===== */
      #agri-store-modal-overlay {
        display: none;
        position: fixed;
        top: 0; left: 0; right: 0; bottom: 0;
        background: rgba(0,0,0,0.55);
        z-index: 99999;
        justify-content: center;
        align-items: flex-start;
        padding-top: 80px;
        backdrop-filter: blur(3px);
      }
      #agri-store-modal-overlay.visible {
        display: flex;
        animation: agriOverlayFadeIn 0.2s ease;
      }
      @keyframes agriOverlayFadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }

      /* ===== MODAL BOX ===== */
      #agri-store-modal {
        background: #fff;
        border-radius: 16px;
        width: 100%;
        max-width: 480px;
        margin: 0 16px;
        box-shadow: 0 25px 60px rgba(0,0,0,0.25);
        overflow: hidden;
        animation: agriModalSlideIn 0.25s ease;
      }
      @keyframes agriModalSlideIn {
        from { transform: translateY(-16px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
      }
      #agri-store-modal .agri-modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 24px 16px;
        border-bottom: 1px solid #f0f0f0;
      }
      #agri-store-modal .agri-modal-title {
        font-size: 18px;
        font-weight: 800;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        color: #1a2e1a;
        margin: 0;
      }
      #agri-store-modal .agri-modal-close {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        border: none;
        background: #f5f5f5;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        color: #666;
        transition: background 0.2s;
        flex-shrink: 0;
      }
      #agri-store-modal .agri-modal-close:hover {
        background: #e5e5e5;
        color: #333;
      }
      #agri-store-modal .agri-modal-stores {
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 12px;
      }

      /* ===== STORE CARDS IN MODAL ===== */
      .agri-store-card {
        border: 2px solid #e8e8e8;
        border-radius: 12px;
        padding: 18px 20px;
        cursor: pointer;
        transition: all 0.2s ease;
        position: relative;
      }
      .agri-store-card:hover {
        border-color: #2d5a27;
        background: #f8fdf8;
      }
      .agri-store-card.selected {
        border-color: #2d5a27;
        background: #f0f7f0;
      }
      .agri-store-card .agri-card-top {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 8px;
      }
      .agri-store-card .agri-card-name {
        font-weight: 800;
        font-size: 15px;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        color: #1a2e1a;
      }
      .agri-store-card .agri-card-badge {
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.08em;
        padding: 3px 10px;
        border-radius: 20px;
        flex-shrink: 0;
      }
      .agri-store-card .agri-card-badge.open {
        background: #dcfce7;
        color: #166534;
      }
      .agri-store-card .agri-card-badge.closed {
        background: #fee2e2;
        color: #991b1b;
      }
      .agri-store-card .agri-card-address {
        font-size: 13px;
        color: #555;
        margin-bottom: 6px;
        line-height: 1.4;
      }
      .agri-store-card .agri-card-hours-text {
        font-size: 12px;
        color: #777;
        margin-bottom: 14px;
      }
      .agri-store-card .agri-card-actions {
        display: flex;
        gap: 8px;
      }
      .agri-store-card .agri-btn-select {
        flex: 1;
        padding: 10px 16px;
        border: none;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        cursor: pointer;
        transition: all 0.2s;
        background: #2d5a27;
        color: #fff;
      }
      .agri-store-card.selected .agri-btn-select {
        background: #1a3a15;
      }
      .agri-store-card .agri-btn-select:hover {
        background: #1a3a15;
        transform: translateY(-1px);
      }
      .agri-store-card .agri-btn-directions {
        padding: 10px 14px;
        border: 2px solid #e0e0e0;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        background: #fff;
        color: #444;
        text-decoration: none;
        display: flex;
        align-items: center;
        gap: 4px;
        transition: all 0.2s;
        white-space: nowrap;
      }
      .agri-store-card .agri-btn-directions:hover {
        border-color: #2d5a27;
        color: #2d5a27;
      }
      .agri-selected-check {
        position: absolute;
        top: 16px;
        right: 56px;
        width: 20px;
        height: 20px;
        background: #2d5a27;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 11px;
        font-weight: bold;
      }

      @media (max-width: 480px) {
        #agri-store-selector-bar .agri-ss-phone { display: none; }
        #agri-store-modal { margin: 0 8px; }
      }
    `;
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }

  // ============================================================
  // BUILD THE HEADER BAR WIDGET
  // ============================================================
  function buildSelectorBar(store) {
    var status = getStoreStatus(store);
    var container = document.getElementById('mighty-location-selector');
    if (!container) {
      // Create it and try to insert near header
      container = document.createElement('div');
      container.id = 'mighty-location-selector';
      var header = document.querySelector('header') || document.body.firstElementChild;
      if (header) header.appendChild(container);
      else document.body.insertBefore(container, document.body.firstChild);
    }

    container.innerHTML = `
      <div id="agri-store-selector-bar" role="button" aria-label="Select store location" tabindex="0">
        <div class="agri-ss-info">
          <span class="agri-ss-location">${store.shortName}</span>
          <span class="agri-ss-city">${store.city}</span>
          <span class="agri-ss-phone">(${store.phone})</span>
          <span class="agri-ss-status ${status.isOpen ? 'open' : 'closed'}">${status.text}</span>
        </div>
        <span class="agri-ss-chevron">▼</span>
      </div>
    `;

    var bar = document.getElementById('agri-store-selector-bar');
    bar.addEventListener('click', openModal);
    bar.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') openModal();
    });
  }

  // ============================================================
  // BUILD THE MODAL
  // ============================================================
  function buildModal() {
    var overlay = document.createElement('div');
    overlay.id = 'agri-store-modal-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Select your store');

    overlay.innerHTML = `
      <div id="agri-store-modal">
        <div class="agri-modal-header">
          <h2 class="agri-modal-title">Select Your Store</h2>
          <button class="agri-modal-close" aria-label="Close">&times;</button>
        </div>
        <div class="agri-modal-stores" id="agri-modal-stores-list"></div>
      </div>
    `;

    document.body.appendChild(overlay);

    overlay.querySelector('.agri-modal-close').addEventListener('click', closeModal);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeModal();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  function renderModalStores() {
    var selectedStore = getSelectedStore();
    var list = document.getElementById('agri-modal-stores-list');
    if (!list) return;

    list.innerHTML = STORES.map(function(store) {
      var status = getStoreStatus(store);
      var isSelected = store.id === selectedStore.id;
      return `
        <div class="agri-store-card ${isSelected ? 'selected' : ''}" data-store-id="${store.id}">

          <div class="agri-card-top">
            <span class="agri-card-name">${store.shortName}</span>
            <span class="agri-card-badge ${status.isOpen ? 'open' : 'closed'}">${status.isOpen ? 'Open' : 'Closed'}</span>
          </div>
          <div class="agri-card-address">${store.address}<br>${store.city} ${store.zip}</div>
          <div class="agri-card-hours-text">${status.text} • <a href="tel:${store.phoneRaw}" style="color:#2d5a27;font-weight:600;text-decoration:none;">${store.phone}</a></div>
          <div class="agri-card-actions">
            <button class="agri-btn-select" data-store-id="${store.id}">
              ${isSelected ? '✓ My Store' : 'Shop This Store'}
            </button>
            <a href="${store.directionsUrl}" target="_blank" class="agri-btn-directions">📍 Directions</a>
          </div>
        </div>
      `;
    }).join('');

    // Bind select buttons
    list.querySelectorAll('.agri-btn-select').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        selectStore(btn.getAttribute('data-store-id'));
      });
    });

    // Card click also selects
    list.querySelectorAll('.agri-store-card').forEach(function(card) {
      card.addEventListener('click', function(e) {
        if (!e.target.closest('a')) {
          selectStore(card.getAttribute('data-store-id'));
        }
      });
    });
  }

  // ============================================================
  // OPEN / CLOSE / SELECT
  // ============================================================
  function openModal() {
    renderModalStores();
    var overlay = document.getElementById('agri-store-modal-overlay');
    if (overlay) {
      overlay.classList.add('visible');
      document.body.style.overflow = 'hidden';
      var bar = document.getElementById('agri-store-selector-bar');
      if (bar) bar.classList.add('active');
    }
  }

  function closeModal() {
    var overlay = document.getElementById('agri-store-modal-overlay');
    if (overlay) {
      overlay.classList.remove('visible');
      document.body.style.overflow = '';
      var bar = document.getElementById('agri-store-selector-bar');
      if (bar) bar.classList.remove('active');
    }
  }

  function selectStore(storeId) {
    setCookie(COOKIE_NAME, storeId, COOKIE_DAYS);
    var store = null;
    for (var i = 0; i < STORES.length; i++) {
      if (STORES[i].id === storeId) { store = STORES[i]; break; }
    }
    if (store) {
      buildSelectorBar(store);
      closeModal();
    }
  }

  // ============================================================
  // INIT
  // ============================================================
  function init() {
    injectStyles();
    var selectedStore = getSelectedStore();
    buildSelectorBar(selectedStore);
    buildModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();